import { useEffect, useState } from "react";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { api } from "@/lib/api";

export default function ContentPage({ name, title }) {
  const [text, setText] = useState(null);
  useEffect(() => {
    api.get(`/public/content/${name}`).then((r) => setText(r.data.text)).catch(() => setText("This page couldn't be loaded. Please try again later."));
  }, [name]);
  const [first, ...rest] = (text || "").split("\n");
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main className="mx-auto max-w-3xl px-4 py-10 sm:px-6" data-testid={`content-page-${name}`}>
        <h1 className="text-3xl font-extrabold text-slate-900 sm:text-4xl">{title}</h1>
        {text === null ? <p className="mt-6 text-slate-500">Loading…</p> : (
          <div className="mt-6 whitespace-pre-line text-base leading-relaxed text-slate-800">
            {first.trim().toLowerCase() === title.toLowerCase() ? rest.join("\n").trim() : text}
          </div>
        )}
      </main>
      <SiteFooter />
    </div>
  );
}
